import { makeWidthFlexible, XYPlot } from 'react-vis';

export const FlexibleXYPlot = makeWidthFlexible(XYPlot);
